<div>

    <div class="row" style="margin-top: 20px;">
        <div class="col-lg-1">
            <p class="title-descriptor">Filtrar Por:</p>
        </div>
        <div class="col-lg-2">
            <mat-form-field>
                
                <mat-label>Región</mat-label>
                <mat-select id="region" name="region" class="selectMedio"  (selectionChange)="seleccionarRegion($event.value)">
                    <mat-option [value]="0">Seleccione Región</mat-option>
                    <mat-option [value]="regiones.idRegion" *ngFor="let regiones of regiones">{{regiones.nombre}}</mat-option>
                </mat-select>
            </mat-form-field>  
        </div>
        <div class="col-lg-2">
            <mat-form-field>
                <mat-label>Comuna</mat-label>
                <mat-select id="comuna" class="selectMedio" name="comuna" (selectionChange)="seleccionarComuna($event.value)">
                    <mat-option [value]="0">Seleccione Comuna</mat-option>
                    <mat-option [value]="comunas.idComuna" *ngFor="let comunas of arrayComunas">{{comunas.nombre}}</mat-option>
                </mat-select>
            </mat-form-field>   
        </div>
        <div class="col-lg-2">
            <mat-form-field>
                <mat-label>Programa</mat-label>
                <mat-select  placeholder="" floatlLabel="never" id="programa" class="selectMedio" name="programa" (selectionChange)="seleccionarPrograma($event.value)">
                    <mat-option value="0">Seleccione Programa</mat-option>
                    <mat-option [value]="programas.idTablaMaestra" *ngFor="let programas of programas">{{programas.descripcionLarga}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-lg-5 d-flex justify-content-end" >
          <input class="form-control me-sm-2" type="text" (keyup.enter)="buscar(palabraClave)" [(ngModel)]="palabraClave" style="width: 300px; height: 45px;" placeholder="Buscar">
                  <button class="btn btn-secondary" type="submit" (click)="buscar(palabraClave)" style="width: 130px;height: 45px;"><i class="fas fa-search"></i> Buscar</button>
        </div>
      </div>

      <div class="row">
        <div class="d-flex justify-content-end">
            <a class="btn" [attr.href]="apiEndpoint + 'adminUsuarioInformes/10'" target=”_blank”  style="width: 40px;border-radius: 50%;background-color: #597CEE;color: #fff;"> <i class="fas fa-download"></i> </a>
        </div>
      </div>
    <div>
    <!-- <div class="example-loading-shade"
            *ngIf="isLoadingResults">
        <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
    </div> -->

        <table class="tables-info" mat-table [dataSource]="dataSource" matSort>

            <ng-container matColumnDef="region">
                <th mat-header-cell *matHeaderCellDef > Región </th>
                <td mat-cell *matCellDef="let row" > {{row.region}} </td>
            </ng-container>

            <ng-container matColumnDef="comuna">
                <th mat-header-cell *matHeaderCellDef > Comuna </th>
                <td mat-cell *matCellDef="let row" > {{row.comuna}} </td>
            </ng-container>

            <ng-container matColumnDef="programa">
                <th mat-header-cell *matHeaderCellDef > Programa </th>
                <td mat-cell *matCellDef="let row" > {{row.programa}} </td>
            </ng-container>

            <ng-container matColumnDef="codigo">
                <th mat-header-cell *matHeaderCellDef > Código JI </th>
                <td mat-cell *matCellDef="let row" > {{row.codigo}} </td>
            </ng-container>

            <ng-container matColumnDef="jardin">
                <th mat-header-cell *matHeaderCellDef > Nombre JI </th>
                <td mat-cell *matCellDef="let row" > {{row.nombre}} </td>
            </ng-container>
            
            <ng-container matColumnDef="puntaje">
                <th mat-header-cell *matHeaderCellDef class="centre"> Puntaje Validacion </th>
                <td mat-cell *matCellDef="let row" class="centre"> {{row.puntajeValidacion}} </td>
            </ng-container>

            <ng-container matColumnDef="egapelados">
                <th mat-header-cell *matHeaderCellDef class="centre"> N° EG Apelados </th>
                <td mat-cell *matCellDef="let row" class="centre"> {{row.egApelados}} </td>
            </ng-container>

            <ng-container matColumnDef="fechaApelacion">
                <th mat-header-cell *matHeaderCellDef class="centre"> Fecha Apelación </th>
                <td mat-cell *matCellDef="let row" class="centre"> {{row.fechaApelacion | date:'dd-MM-yyyy'}} </td>
            </ng-container>

            <ng-container matColumnDef="estado">
                <th mat-header-cell *matHeaderCellDef class="centre"> Estado</th>
                <td mat-cell *matCellDef="let row" class="centre">  
                    <div *ngIf="row.resolucion==1"><p style="color: #EE366D;">No Iniciada</p></div> 
                    <div *ngIf="row.resolucion==2"><p style="color: #F5BB3F;">En Proceso</p></div> 
                    <div *ngIf="row.resolucion==3"><p style="color: #00B09E;">Finalizada</p></div>
                </td>
            </ng-container>

            <ng-container matColumnDef="puntajeFinal">
                <th mat-header-cell *matHeaderCellDef class="centre"> Puntaje Final</th>
                <td mat-cell *matCellDef="let row; let i = index" class="centre"> 
                    {{row.puntajeFinal}}
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <mat-paginator
            [length]="length"
            [pageIndex]="pageIndex"
            
            [pageSizeOptions]="[10, 50, 100]"
            [showFirstLastButtons]="true"
            (page)="getServerData($event)">
        </mat-paginator>
    </div>
</div>

<ngx-spinner></ngx-spinner>